module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开启小票机"
    }
  }, [_c('el-switch', {
    attrs: {
      "width": 60,
      "active-value": "true",
      "inactive-value": "false",
      "inactive-color": "#ccc",
      "active-text": "开启",
      "inactive-text": "关闭",
      "active-color": "#13ce66"
    },
    model: {
      value: (_vm.form.is_open),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_open", $$v)
      },
      expression: "form.is_open"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "隐藏收货人"
    }
  }, [_c('el-switch', {
    attrs: {
      "width": 60,
      "active-value": "true",
      "inactive-value": "false",
      "inactive-color": "#ccc",
      "active-text": "开启",
      "inactive-text": "关闭",
      "active-color": "#13ce66"
    },
    model: {
      value: (_vm.form.is_hide),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_hide", $$v)
      },
      expression: "form.is_hide"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户ID"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "用户ID"
    },
    model: {
      value: (_vm.form.person_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "person_id", $$v)
      },
      expression: "form.person_id"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_c('a', {
    attrs: {
      "href": "http://dev.10ss.net/admin/listapp",
      "target": "_blank"
    }
  }, [_vm._v("应用列表地址，点击进入应用，进行查询")])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "应用ID"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "用户ID"
    },
    model: {
      value: (_vm.form.app_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "app_id", $$v)
      },
      expression: "form.app_id"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_c('a', {
    attrs: {
      "href": "http://dev.10ss.net/admin/listapp",
      "target": "_blank"
    }
  }, [_vm._v("应用列表地址，点击进入应用，进行查询")])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "应用密钥"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "用户ID"
    },
    model: {
      value: (_vm.form.app_key),
      callback: function($$v) {
        _vm.$set(_vm.form, "app_key", $$v)
      },
      expression: "form.app_key"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_c('a', {
    attrs: {
      "href": "http://dev.10ss.net/admin/listapp",
      "target": "_blank"
    }
  }, [_vm._v("应用列表地址，点击进入应用，进行查询")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4235cbe2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4235cbe2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/setting/yilianyun/setting.vue
// module id = 2666
// module chunks = 0